import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { PARTNER_BRAND } from '../../partnerDashboardTheme';

const BlockCommunityMemberDialog = ({ open, memberName, blocking = false, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={blocking ? undefined : onClose}
    PaperProps={{
      sx: {
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
      },
    }}
  >
    <DialogContent sx={{ pb: 1, pt: 1 }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          bgcolor: '#fef2f2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <BlockOutlinedIcon sx={{ fontSize: 32, color: '#dc2626' }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Block Community Member?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        Block{' '}
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {memberName || 'this member'}
        </Box>
        ? They will lose access to this community and will no longer be able to participate in
        discussions.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
      <Button
        variant="outlined"
        disabled={blocking}
        onClick={onClose}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          color: PARTNER_BRAND,
          borderColor: PARTNER_BRAND,
          '&:hover': {
            borderColor: 'primary.dark',
            bgcolor: 'rgba(224, 104, 10, 0.04)',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={blocking}
        onClick={onConfirm}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          bgcolor: '#dc2626',
          boxShadow: 'none',
          '&:hover': {
            bgcolor: 'error.dark',
            boxShadow: 'none',
          },
        }}
      >
        {blocking ? 'Blocking…' : 'Block'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default BlockCommunityMemberDialog;
